exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ResizeHandle {\n    position: absolute;\n    left: 50%;\n    top: -8px;\n    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);\n    border-radius: 2;\n    width: 40px;\n    height: 12px;\n    background: #fff;\n    z-index: 1500;\n    cursor: grab;\n    cursor: -moz-grab;\n    cursor: -webkit-grab;\n}\n\n.ResizeHandle:hover,\n.ResizeHandle:active {\n    transform: scale(1.03);\n    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);\n}\n\n.ResizeHandle:active {\n    cursor: grabbing;\n    cursor: -moz-grabbing;\n    cursor: -webkit-grabbing;\n }\n\n.ResizeHandle svg {\n    margin-left: 8px;\n    margin-top: -6px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/datatable/ResizeHandle.css
// module id = 1025
// module chunks = 0